import { render, staticRenderFns } from "./audiotool.vue?vue&type=template&id=0c57e035"
import script from "./audiotool.vue?vue&type=script&lang=js"
export * from "./audiotool.vue?vue&type=script&lang=js"
import style0 from "./audiotool.vue?vue&type=style&index=0&id=0c57e035&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports